import { camelCase } from 'lodash';

function keysToCamelCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map((v) => keysToCamelCase(v));
  }

  if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [camelCase(key)]: keysToCamelCase(obj[key]),
      }),
      {},
    );
  }

  return obj;
}

export default keysToCamelCase;
